import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public settings: any;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<any> {
    const data = await firstValueFrom(
      this.http.get('assets/appsettings.json')
    );
    this.settings = data;
    console.log('Config response:', data);
    return data;
  }
}
